module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "answer-screen"
  }, [(_vm.survey && _vm.participant && !_vm.submited) ? _c('div', {
    attrs: {
      "id": "wrapper-survey-answer"
    }
  }, [(_vm.survey.questions.length > 0 && _vm.currentQuestion === null) ? _c('div', [(_vm.survey.questions.length > 0 && _vm.currentQuestion === null) ? _c('div', [(_vm.survey.$scopQuestionnaire) ? _c('div', {
    staticClass: "content-body welcome"
  }, [_vm._v("\n          Bonjour,"), _c('br'), _c('br'), _vm._v("\n\n          Comme l'ensemble des sociétés coopératives, Acome, en tant que SCOP, doit obligatoirement effectuer l’audit coopératif afin de pouvoir obtenir son agrément ministériel."), _c('br'), _c('br'), _vm._v("\n\n          ARESCOP, l’Association de Révision des Sociétés Coopératives, mise en place par la Confédération Générale des SCOP, a été retenue pour conduire cette mission."), _c('br'), _c('br'), _vm._v("\n\n          Un des objectifs de la révision coopérative est d'apprécier votre perception de la vie coopérative et de son fonctionnement au sein d‘Acome."), _c('br'), _c('br'), _vm._v("\n\n          Dans ce cadre, nous adressons un questionnaire à l'ensemble des associés d’Acome. Cette enquête est ANONYME et a pour but de faire ressortir des éléments dominants et non des prises de positions individuelles. C'est donc en toute confiance que nous devrons travailler ensemble."), _c('br'), _c('br'), _vm._v("\n\n          Nous vous remercions de bien vouloir consacrer du temps à ce moment d’expression important dans la vie de votre coopérative et de contribuer ainsi à l'audit que nous entreprenons."), _c('br'), _c('br'), _vm._v("\n\n          En tant que salarié, si vous n’êtes pas encore associé, vous n’aurez pas accès aux questions de la Révision coopérative mais serez renvoyé directement à l’enquête relative à la Qualité de Vie au Travail (QVT)."), _c('br'), _c('br'), _vm._v("\n          Ce questionnaire peut comporter jusqu'à " + _vm._s(_vm.survey.questions.length) + " questions.\n        ")]) : _c('div', {
    staticClass: "content-body welcome"
  }, [_vm._v("\n          Bonjour, vous allez répondre à une enquête de façon anonyme."), _c('br'), _c('br'), _vm._v("\n          Cette enquête " + _vm._s(_vm.survey.scopQuestionnaire ? "peut comprter jusqu'à" : "comporte") + " " + _vm._s(_vm.survey.questions.length) + " questions et ne vous prendra que peu de temps."), _c('br'), _c('br'), _vm._v("\n          Nous comptons sur vous pour avoir une vision la plus objective possible."), _c('br'), _c('br'), _vm._v("\n          Cliquez sur \"Commencer\" quand vous êtes prêt.\n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('v-btn', {
    staticClass: "answers-buttom elevation-0 deep-purple accent-2 white--text",
    attrs: {
      "large": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.start($event)
      }
    }
  }, [_vm._v("Commencer")])], 1)]) : (_vm.currentQuestion) ? _c('div', {
    staticStyle: {
      "position": "absolute",
      "top": "140px",
      "right": "0",
      "bottom": "0",
      "left": "0",
      "text-align": "center"
    }
  }, [_c('div', [(_vm.getCategory(_vm.currentQuestion)) ? _c('div', {
    staticClass: "category"
  }, [_vm._v("\n          " + _vm._s(_vm.getCategory(_vm.currentQuestion)) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('h1', {
    staticClass: "question-label",
    style: (("margin-top: " + (_vm.currentQuestion.questionnaire ? "40" : "100") + "px;"))
  }, [_vm._v("\n          " + _vm._s(_vm.currentQuestion.label) + "\n        ")]), _vm._v(" "), _c('h2', {
    staticClass: "question-sub-label"
  }, [_vm._v("\n          " + _vm._s(_vm.currentQuestion.subLabel) + "\n        ")])]), _vm._v(" "), (_vm.currentQuestion.questionnaire) ? _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "text-xs-center": ""
    }
  }, [_c('v-flex'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": "",
      "text-xs-center": ""
    }
  }, [_c('question', {
    on: {
      "next": _vm.nextQuestion
    }
  })], 1), _vm._v(" "), _c('v-flex')], 1)], 1) : _c('div', [_c('div', {
    staticClass: "pb-4 mb-4 survey-answer-happiness-wrapper"
  }, [_c('div', {
    staticClass: "survey-answer-happiness"
  }, [_c('div', {
    class: ['happiness-btn', 'survey-answer-happiness-1', {
      selected: _vm.currentScore === 0
    }],
    on: {
      "click": function($event) {
        _vm.answer(0)
      }
    }
  }, [_c('div', {
    staticClass: "halo"
  }), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("sentiment_dissatisfied")])], 1), _vm._v(" "), _c('div', {
    class: ['happiness-btn', 'survey-answer-happiness-2', {
      selected: _vm.currentScore === 1
    }],
    on: {
      "click": function($event) {
        _vm.answer(1)
      }
    }
  }, [_c('div', {
    staticClass: "halo"
  })]), _vm._v(" "), _c('div', {
    class: ['happiness-btn', 'survey-answer-happiness-3', {
      selected: _vm.currentScore === 2
    }],
    on: {
      "click": function($event) {
        _vm.answer(2)
      }
    }
  }, [_c('div', {
    staticClass: "halo"
  })]), _vm._v(" "), _c('div', {
    class: ['happiness-btn', 'survey-answer-happiness-4', {
      selected: _vm.currentScore === 3
    }],
    on: {
      "click": function($event) {
        _vm.answer(3)
      }
    }
  }, [_c('div', {
    staticClass: "halo"
  })]), _vm._v(" "), _c('div', {
    class: ['happiness-btn', 'survey-answer-happiness-5', {
      selected: _vm.currentScore === 4
    }],
    on: {
      "click": function($event) {
        _vm.answer(4)
      }
    }
  }, [_c('div', {
    staticClass: "halo"
  }), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("sentiment_satisfied")])], 1)])]), _vm._v(" "), (!_vm.currentQuestion.isVerbatim) ? _c('div', {
    staticClass: "answer-confirm pt-4 mt-4"
  }, [_c('div', {
    staticClass: "mt-4"
  }, [_c('v-btn', {
    staticClass: "answers-buttom elevation-0 deep-purple accent-2 white--text",
    style: ({
      opacity: _vm.currentScore === null ? 0 : 1,
    }),
    attrs: {
      "large": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.confirmAnswer($event)
      }
    }
  }, [_vm._v("Valider")])], 1)]) : _vm._e()]), _vm._v(" "), (_vm.currentQuestion.isVerbatim && _vm.currentScore !== null) ? _c('div', {
    staticClass: "survey-answer-verbatim"
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": _vm.currentQuestion.verbatimHelper || "Apportez des précisions sur votre réponse ici...",
      "multi-line": ""
    },
    model: {
      value: (_vm.currentVerbatim),
      callback: function($$v) {
        _vm.currentVerbatim = $$v
      },
      expression: "currentVerbatim"
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.maxVerbatimLength) + " caractères maximum\n          "), (_vm.currentVerbatim.length <= 250) ? _c('span', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("(" + _vm._s(_vm.maxVerbatimLength - _vm.currentVerbatim.length) + " restant)")]) : _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("(" + _vm._s(_vm.currentVerbatim.length) + " utilisés)")]), _vm._v(".\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "survey-answer-verbatim-button-wrapper"
  }, [_c('v-btn', {
    staticClass: "answers-buttom elevation-0 deep-purple accent-2 white--text",
    attrs: {
      "large": "",
      "flat": "",
      "disabled": _vm.currentVerbatim.length > _vm.maxVerbatimLength
    },
    nativeOn: {
      "click": function($event) {
        _vm.answerVerbatim($event)
      }
    }
  }, [_vm._v("Valider")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "answer-footer-wrapper"
  }, [_c('div', {
    staticClass: "answer-footer progress"
  }, [_vm._v("\n          " + _vm._s(_vm.currentQuestion.index + 1) + "/" + _vm._s(_vm.survey.questions.length) + "\n        ")])])]) : _vm._e()]) : (_vm.submited) ? _c('div', [_c('div', {
    staticClass: "content-body welcome"
  }, [_vm._v("\n        Merci d'avoir répondu ! Vous pouvez passer la tablette à la personne suivante après avoir cliqué sur \"Terminer\", à bientôt !\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('v-btn', {
    staticClass: "answers-buttom elevation-0 deep-purple accent-2 white--text",
    attrs: {
      "large": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.goToHome($event)
      }
    }
  }, [_vm._v("Terminer")])], 1)]) : _c('div', [_vm._v("Pas de données de particpant ni de diagnostic")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-538bffe8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AnswerScreen.vue
// module id = 323
// module chunks = 1